// Homland blog listing — tag filter and load-more (sections/main-blog.liquid)
(function () {
  'use strict';

  function initBlogWrapper(mainWrapper) {
    var sectionId = mainWrapper.dataset.sectionId;
    if (!sectionId) return;

    var initialLimit = parseInt(mainWrapper.dataset.limit, 10) || 12;
    var visibleLimit = initialLimit;
    var currentTag = 'all';
    var isLoading = false;
    var loadingLabel = mainWrapper.dataset.loadingLabel || 'Loading...';

    var loadMoreBtn = document.getElementById('LoadMoreArticlesBtn-' + sectionId);
    var articleGrid = document.getElementById('CustomArticleGrid-' + sectionId);
    var noArticlesMsg = document.getElementById('NoArticlesMessage-' + sectionId);

    function applyFilter() {
      var matchingCards = [];
      var articles = mainWrapper.querySelectorAll('.custom-article-card');

      articles.forEach(function (card) {
        var tagsArray = (card.getAttribute('data-tags') || '').split(' ').filter(Boolean);
        if (currentTag === 'all' || tagsArray.includes(currentTag)) {
          matchingCards.push(card);
        } else {
          card.style.display = 'none';
        }
      });

      var visibleCount = 0;
      matchingCards.forEach(function (card, index) {
        if (index < visibleLimit) {
          card.style.display = 'flex';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      var hasHiddenCache = matchingCards.length > visibleLimit;
      var hasMorePages = loadMoreBtn && loadMoreBtn.getAttribute('data-next-url');

      if (loadMoreBtn) {
        loadMoreBtn.style.display = hasHiddenCache || hasMorePages ? 'inline-flex' : 'none';
      }

      if (noArticlesMsg) {
        noArticlesMsg.style.display = visibleCount === 0 && !hasMorePages ? 'block' : 'none';
      }

      return visibleCount;
    }

    function getMatchingCount() {
      var count = 0;
      mainWrapper.querySelectorAll('.custom-article-card').forEach(function (card) {
        var tagsArray = (card.getAttribute('data-tags') || '').split(' ').filter(Boolean);
        if (currentTag === 'all' || tagsArray.includes(currentTag)) count++;
      });
      return count;
    }

    async function fetchNextPage() {
      if (!loadMoreBtn || isLoading) return false;
      var nextUrl = loadMoreBtn.getAttribute('data-next-url');
      if (!nextUrl) return false;

      isLoading = true;
      var originalText = loadMoreBtn.innerText;
      loadMoreBtn.innerText = loadingLabel;
      loadMoreBtn.classList.add('is-loading');

      try {
        var response = await fetch(nextUrl);
        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newArticles = doc.querySelectorAll('.custom-article-card');

        if (newArticles.length > 0 && articleGrid) {
          newArticles.forEach(function (article) {
            article.style.display = 'none';
            articleGrid.appendChild(article);
          });
        }

        var newLoadMoreBtn = doc.getElementById('LoadMoreArticlesBtn-' + sectionId);
        if (newLoadMoreBtn && newLoadMoreBtn.getAttribute('data-next-url')) {
          loadMoreBtn.setAttribute('data-next-url', newLoadMoreBtn.getAttribute('data-next-url'));
        } else {
          loadMoreBtn.style.display = 'none';
          loadMoreBtn.removeAttribute('data-next-url');
        }
      } catch (error) {
        console.error('Error loading more articles:', error);
      } finally {
        isLoading = false;
        loadMoreBtn.innerText = originalText;
        loadMoreBtn.classList.remove('is-loading');
      }
      return true;
    }

    async function ensureLimit() {
      var matchingCount = getMatchingCount();
      while (matchingCount < visibleLimit) {
        var hasMore =
          loadMoreBtn &&
          loadMoreBtn.style.display !== 'none' &&
          loadMoreBtn.getAttribute('data-next-url');
        if (!hasMore) break;
        await fetchNextPage();
        matchingCount = getMatchingCount();
      }
      applyFilter();
    }

    applyFilter();

    mainWrapper.querySelectorAll('.custom-tab-btn').forEach(function (btn) {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        mainWrapper.querySelectorAll('.custom-tab-btn').forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        currentTag = this.getAttribute('data-tag');
        visibleLimit = initialLimit;
        if (articleGrid) articleGrid.style.opacity = '0.4';
        await ensureLimit();
        if (articleGrid) articleGrid.style.opacity = '1';
      });
    });

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', async function () {
        visibleLimit += initialLimit;
        if (articleGrid) articleGrid.style.opacity = '0.4';
        await ensureLimit();
        if (articleGrid) articleGrid.style.opacity = '1';
      });
    }
  }

  function init() {
    document.querySelectorAll('.custom-blog-wrapper[data-section-id]').forEach(initBlogWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
